export type Locale = "de" | "fr" | "en";
export const LOCALES: Locale[] = ["de", "fr", "en"];
export const DEFAULT_LOCALE: Locale = LOCALES[0];
